import { Link, styled } from '@mui/material'

export const PlainLink = styled(Link)(() => ({
    textDecoration: 'none',
    cursor: 'pointer',
}))
